(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-faq-grid"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('[data-faq-section-select]').forEach((node)=>{
        node.addEventListener('click',(e)=>{
            document.querySelectorAll('[data-faq-section-select]').forEach((node)=>{
                node.classList.remove('active')
            })
            document.querySelectorAll('[data-faq-section]').forEach((node)=>{
                node.classList.remove('active')
            })
            e.target.closest('[data-faq-section-select]').classList.add('active')
            var target = e.target.closest('[data-faq-section-select]').getAttribute('data-faq-section-select')
            document.querySelector('[data-faq-section="'+target+'"]').classList.add('active')
        })
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-article-grid"] && !Shopify.designMode) return;
  try {
    
    const load_btn = document.querySelector(".custom-filter-load-more");

let products_on_page = document.querySelector('.blog-grid');

let url = products_on_page.getAttribute('data-next-url');

const spinner = document.querySelector('.load-more-spinner');

if (load_btn) {
    if (url === '') {
        load_btn.style.display = 'none';
    }

    load_btn.addEventListener("click", () => {

        spinner.classList.add("show");

        fetch(url)
            .then(function(response) {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error('Network response was not ok.');
                }
            })
            .then(function(data) {
                const html = document.createElement('div');
                html.innerHTML = data;

                let links = html.querySelector('.pagination-links').innerHTML;
                document.querySelector('.pagination-links').innerHTML = links;

                let new_grid = html.querySelector('.blog-grid');
                url = new_grid.getAttribute('data-next-url');
                if (url === '') {
                    load_btn.style.display = 'none';
                }
                //let new_products = new_grid.querySelectorAll(".product-card, #collection-grid-cta, #collection-grid-cta-2");
                let new_products = new_grid.querySelectorAll(".article-card");

                new_products.forEach(new_prod => {
                    products_on_page.append(new_prod);
                });
                spinner.classList.remove("show");
                document.dispatchEvent(new CustomEvent('pagination-done'))
            })
            .catch(function(error) {
                window.log(error);
            });


    })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-main-search"] && !Shopify.designMode) return;
  try {
    
    const load_btn = document.querySelector(".custom-filter-load-more");

let products_on_page = document.querySelector('.search-grid');

let url = products_on_page.getAttribute('data-next-url');

const spinner = document.querySelector('.load-more-spinner');

if (load_btn) {
    if (url === '') {
        load_btn.style.display = 'none';
    }

    load_btn.addEventListener("click", () => {

        spinner.classList.add("show");

        fetch(url)
            .then(function(response) {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error('Network response was not ok.');
                }
            })
            .then(function(data) {
                const html = document.createElement('div');
                html.innerHTML = data;

                let links = html.querySelector('.pagination-links').innerHTML;
                document.querySelector('.pagination-links').innerHTML = links;

                let new_grid = html.querySelector('.search-grid');
                url = new_grid.getAttribute('data-next-url');
                if (url === '') {
                    load_btn.style.display = 'none';
                }
                //let new_products = new_grid.querySelectorAll(".product-card, #collection-grid-cta, #collection-grid-cta-2");
                let new_products = new_grid.querySelectorAll(".product-card");

                new_products.forEach(new_prod => {
                    products_on_page.append(new_prod);
                });
                spinner.classList.remove("show");
                document.querySelectorAll('.product-card .swiper:not(.swiper-initialized)').forEach((node)=>{
                    new window.swiper(node, {
                        navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        },
                        spaceBetween: 10,
                        cssMode: true,
                        noSwiping: true,
                        noSwipingClass: 'swiper-slide',
                    })
                })
                document.dispatchEvent(new CustomEvent('pagination-done'))
            })
            .catch(function(error) {
                window.log(error);
            });


    })
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-card .swiper:not(.swiper-initialized)').forEach((node)=>{
      new window.swiper(node, {
          navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          },
          spaceBetween: 10,
          cssMode: true,
          noSwiping: true,
          noSwipingClass: 'swiper-slide',
      })
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-collection-grid"]) return;
  try {
    
  document.querySelectorAll('.show-filters,.hide-filters').forEach((node)=>{
    node.addEventListener('click',(e)=>{
      if(document.querySelector('#qf-filter-wrapper').classList.contains('filters-active-desk') == true){
        document.querySelector('#qf-filter-wrapper').classList.remove('filters-active-desk')
        if(window.innerWidth < 1025){
          document.querySelector('#qf-filter-wrapper').classList.toggle('filters-active')
        }
      }
      else{
        document.querySelector('#qf-filter-wrapper').classList.toggle('filters-active')
      }
    })
  })
  document.querySelectorAll('#SortBy').forEach((node)=>{
    node.addEventListener('change',(e)=>{
      var value = e.target.value
      document.querySelector('[name="sort_by"]').value = value
      var form = document.querySelector('[name="sort_by"]').closest('form')
      if(form.querySelector('.max-price-filter') != null && form.querySelector('.min-price-filter') != null){
        if(form.querySelector('.max-price-filter').value == form.querySelector('.max-price-filter').max && form.querySelector('.min-price-filter').value == form.querySelector('.min-price-filter').min){
          form.querySelector('.min-price-filter').removeAttribute('value')
          form.querySelector('.max-price-filter').removeAttribute('value')
          form.submit()
        }
      }
      else{
        form.submit()
      }
    })
  })
  

  } catch(e) { console.error(e); }
})();
})();
